import React from 'react';
import styles from './DropdownMenu.module.css';

const DropdownElement = ({ classPrefix = "", onClick, removeHover = false, children, customClass = "" }) => {
    const baseClass = `${classPrefix ? classPrefix : ""} ${styles.dropdownElement}`;
    const fullClass = removeHover ? `${baseClass} ${styles.dropdownSpace}` : baseClass;

    return (
        <div className={`${fullClass.trim()} ${customClass}`} onClick={onClick}>
            {children}
        </div>
    );
};

export default DropdownElement;